import * as actionTypes from 'constants/ActionTypes';

const user = (state = {
    user: {},
    isLogged: false,
    message: '',
}, action) => {
    switch (action.type) {
        /* AUTH USER ----------------------- */
        case actionTypes.AUTH_USER.REQUEST:
            return {
                ...state,
            };
        case actionTypes.AUTH_USER.SUCCESS:
            return {
                ...state,
                user: action.data,
                isLogged: true,
                message: '',
            };
        case actionTypes.AUTH_USER.FAILURE:
            return {
                ...state,
                user: {},
                isLogged: false,
                message: action.message,
            };
        /* GET USER ----------------------- */
        case actionTypes.GET_USER.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_USER.SUCCESS:
            return {
                ...state,
                user: action.data,
                isLogged: true,
                message: '',
            };
        case actionTypes.GET_USER.FAILURE:
            return {
                ...state,
                user: {},
                isLogged: false,
                message: action.message,
            };
        /* LOGOUT USER ----------------------- */
        case actionTypes.LOGOUT_USER.REQUEST:
            return {
                ...state,
            };
        case actionTypes.LOGOUT_USER.SUCCESS:
            return {
                user: {},
                isLogged: false,
                message: '',
            };
        case actionTypes.LOGOUT_USER.FAILURE:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export default user;



// WEBPACK FOOTER //
// ./app/reducers/users/user.js